/**
 * @generated SignedSource<<c86f1db39e13cb06cce87d702c185c7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type trendingNavBarSwiperQueueQuery$variables = Record<PropertyKey, never>;
export type trendingNavBarSwiperQueueQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type trendingNavBarSwiperQueueQuery = {
  response: trendingNavBarSwiperQueueQuery$data;
  variables: trendingNavBarSwiperQueueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "pwa_subnav_menu"
    }
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "trendingNavBarSwiperQueueQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"pwa_subnav_menu\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "trendingNavBarSwiperQueueQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": "appConfig(filter:{\"entityId\":\"pwa_subnav_menu\"})"
      }
    ]
  },
  "params": {
    "cacheID": "1e9a3c53d4b4d59b688dc9d39c11d94b",
    "id": null,
    "metadata": {},
    "name": "trendingNavBarSwiperQueueQuery",
    "operationKind": "query",
    "text": "query trendingNavBarSwiperQueueQuery {\n  appConfig(filter: {entityId: \"pwa_subnav_menu\"}) {\n    json\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "85aecf011fc267e1108d17afba50254d";

export default node;
